/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Usage_TitleInputs */

const es_privacy_policy_usage_title = /** @type {(inputs: Privacy_Policy_Usage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Como Utilizamos su Informacion`)
};

const en_privacy_policy_usage_title = /** @type {(inputs: Privacy_Policy_Usage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. How We Use Your Information`)
};

/**
* | output |
* | --- |
* | "4. How We Use Your Information" |
*
* @param {Privacy_Policy_Usage_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_usage_title = /** @type {((inputs?: Privacy_Policy_Usage_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Usage_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_usage_title(inputs)
	return en_privacy_policy_usage_title(inputs)
});
export { privacy_policy_usage_title as "privacy_policy.usage.title" }